import { render, staticRenderFns } from "./registerAccount.vue?vue&type=template&id=6089b1b0"
import script from "./registerAccount.vue?vue&type=script&lang=js"
export * from "./registerAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports